export default class FloorplanStatuses {
    static statuses = [
        {
            label : 'Not Selected',
            value : 'N/S'
        },
        {
            label : 'Internal',
            value : 'Internal'
        },
        {
            label : 'Pre-Sale (VIP)',
            value : 'Pre-Sale (VIP)'
        },
        {
            label : 'Pre-Sale (Floorplans)',
            value : 'Pre-Sale (Floorplans)'
        },
        {
            label : 'On Sale',
            value : 'On Sale'
        },
        {
            label : 'Sold Out',
            value : 'Sold Out'
        },
        {
            label : 'Off Market',
            value : 'Off Market'
        },
        {
            label : 'Available Homes (QMI)',
            value : 'QMI'
        }
    ]

    static label(value) {
        return FloorplanStatuses.statuses.find(level => level.value === (value ?? 'N/S'))?.label;
    }
}